import { Button } from '@mui/material'
import React from 'react'
import { BootstrapTooltip } from '../../../../components/Tooltips/CustomizedTooltips'
import { ReactComponent as Excel } from '@assets/svg/excel.svg'
import { exportToExcel } from '@utils/newExportExclel'
import moment from 'moment'
import { ReportContextType, useOTSuppliesReportContext } from '@pages/OTSuppliesReport/context/OTSuppliesReport.context'

const BtnExcel = () => {
  const { ctxReport } = useOTSuppliesReportContext() as ReportContextType
  return (
    <div className='d-flex justify-content-end h-100  my-2'>
      <BootstrapTooltip title='Descargar Reporte en .xsl'>
        <Button
          disabled={ctxReport.data === null}
          variant='contained' color='success' size='small' className='m-2'
          onClick={() => exportToExcel(
            ctxReport.data.items.map((row: any) => {
              return {
                OT: String(row.id),
                Prioridad: row.priority === 1 ? 'SI' : 'NO',
                'Estado Actual OT': row.last_status_name,
                'Fecha Actual': row.last_status_date ? moment(row.last_status_date).format('DD-MM-YYYY HH:mm:ss') : null,
                'Ingresado a ST': row.in_st,
                'Fecha Ingreso a ST': row.in_st_date ? moment(row.in_st_date).format('DD-MM-YYYY HH:mm:ss') : null,
                'Tipo de Documento': row.type_document === 0 ? 'Boleta' : row.type_document === 1 ? 'Factura' : row.type_document === 2 ? 'Guia de despacho' : 'IMEI/SERIAL',
                'Número Boleta': row.id_invoice,
                'Fecha de Venta': row.date_invoice === null ? 'S/I' : row.date_invoice,
                'Canal de Venta': row.channel_name,
                Cliente: row.client_name,
                'Rut Cliente': row.client_rut,
                'Correo Cliente': row.client_email,
                Teléfono: row.client_phone,
                Producto: row.product_name,
                'Serial/IMEI': row.product_serial,
                SKU: row.product_sku,
                'Unidad de Negocio (sbu)': row.business_unit,
                'Tipo Flujo': row.name_flow,
                'Tipo de Ingreso': row.reception_type,
                'Solicitud Codigo Desbloqueo': row.flag_unlock_code === 1 ? 'SI' : 'NO',
                'Solicitud Desvinculación': row.flag_disassociation === 1 ? 'SI' : 'NO',
                Código: row.unlock_code,
                'Estado Diagnostico': row.diagnostic_information,
                'Estado Información': row.information_status,
                'Tipo de Falla': row.failure_name,
                'Observación Falla': row.failure_description,
                'Estado Cosmetico': row.cosmetic_description,
                'Categoria Cosmetica': row.id_cosmetic_status + '-' + row.category_cosmetic,
                'Pieza Falla Principal': row.main_component_failure,
                'Observación Pieza Falla Principal': row.comments_ppl_failure,
                'Usuario Notificado': parseInt(row.client_notification) === 1 ? 'SI' : 'NO',
                Diagnostico: row.diagnostic_information,
                'Fecha Creación': moment(row.created_at).utc().format('DD-MM-YYYY HH:mm:ss'),
                'Numero NC': row.NC_number,
                'Fecha NC': row.NC_date,
                'Bodega NC': row.warehouse_NC,
                'Bodega Ingreso': row.warehouse_reception,
                'Bodega Traspaso': row.warehouse_transfer,
                'Usuario Recepción': row.name_user_register,
                'Usuario Asignado': row.name_user_assigned,
                'Tecnico Asignado': row.name_assigned_technician,
                'Días disponible ST': Math.sign(row.day_diagnostico_ST) === -1 ? Math.abs(row.day_diagnostico_ST) : parseInt(row.day_diagnostico_ST),
                'Días notificado ST': Math.sign(row.diagnosis_notifications_days) === -1 ? Math.abs(row.diagnosis_notifications_days) : parseInt(row.diagnosis_notifications_days),
                'Días totales': Math.sign(row.day_total) === -1 ? Math.abs(row.day_total) : parseInt(row.day_total),
                'Categoria insumo': row.category,
                'Familia insumo': row.family,
                'SubFamilia insumo': row.subfamily,
                'SKU insumo': row.sku,
                'Nombre insumo': row.name,
                'Variante color insumo': row.variant_color
              }
            }),
            'Reporte OT'
          )}
        >
          <Excel className='me-2' /> Descargar Informe
        </Button>
      </BootstrapTooltip>
    </div>
  )
}

export default BtnExcel
